import { useTranslation } from 'react-i18next';
import { DropdownStyled } from 'src/components';
import { SortItems } from '.';
import { type OrgSortBy } from 'src/types';

type Props = {
  sortBy: OrgSortBy;
  setSortBy: (sortBy: OrgSortBy) => void;
};

export const SortByDropdown = ({ sortBy, setSortBy }: Props) => {
  const { t } = useTranslation();

  return (
    <DropdownStyled
      className='w-[180px] min-w-[180px] max-w-[180px]'
      buttonContent={
        <div className='flex flex-row flex-nowrap items-center justify-center gap-2 pr-1.5'>
          <span className='whitespace-nowrap font-secondary text-sm font-normal leading-4 text-primary-dark'>
            {t('org_settings.sort_by')}:
          </span>
          <span className='truncate whitespace-nowrap font-secondary text-base font-semibold leading-4 text-primary-dark'>
            {t(`org_settings.sort.${sortBy}`)}
          </span>
        </div>
      }
      darkStyle={false}
    >
      {(closeDropdown) => (
        <div className='z-20 flex min-w-[200px] flex-col items-start justify-center rounded-lg bg-cloudGray font-secondary xs:min-w-[240px]'>
          <div className='flex w-full flex-col items-start gap-2 py-4 pl-6 pr-4 font-semibold'>
            <SortItems
              handleClick={closeDropdown}
              sortBy={sortBy}
              setSortBy={setSortBy}
            />
          </div>
        </div>
      )}
    </DropdownStyled>
  );
};
